import React, { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useOktaAuth } from '@okta/okta-react'
import FlowRouter from './components/flow/FlowRouter'
import LoginCallback from './components/flow/LoginCallback'
import SecureSessionValidator from './components/auth/SecureSessionValidator'
import ErrorPage from './pages/CarelonRx/error/ErrorPage'
import { ThemeProvider } from './contexts/ThemeContext'
import { FlowProvider } from './contexts/FlowContext'
import { SessionProvider } from './contexts/SessionContext'

function App() {
  const { authState } = useOktaAuth()

  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.clear();
    };
    
    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [])

  if (!authState) {
    return <div>Loading...</div>
  }

  return (
    <ThemeProvider>
      <SessionProvider>
        <FlowProvider>
          <Routes>
            <Route path="/" element={
              <SecureSessionValidator>
                <FlowRouter />
              </SecureSessionValidator>
            } />
            <Route path="/login/callback" element={<LoginCallback />} />
            <Route path="/error" element={<ErrorPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </FlowProvider>
      </SessionProvider>
    </ThemeProvider>
  )
}

export default App
